export const DownyMildewEvents = {
  downyMildewSyncStatusUpdated: 'Arable_DownyMildewRecalculationStatusUpdated',
}

export interface DownyMildewSyncStatusUpdatedEvent {
  CustomerId: number;
  CropFieldId: number;
  Status: 'Initiated' | 'Completed' | 'Failed';
  CalculationTaskCode: string;
  Timestamp: Date;
}
